import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { albumImages } from './albumImages';
import './MyGallery.scss';

export default function MyGallery() {
  return (
    <div className="my-gallery-wrapper">
      <ImageGallery items={albumImages} />
    </div>
  );
}
